import { useState } from "react";
import { Sparkles } from "lucide-react";
import { EFFECT_PRESETS } from "../../lib/effects";
import { useLang } from "../../lib/i18n";
import { CostTag } from "./CostTag";

export const EffectsTab = ({ file, onLaunch, disabled, costs = {} }) => {
  const { t, te } = useLang();
  const [prompt, setPrompt] = useState("");
  const [error, setError] = useState("");
  const isVideo = file.kind === "video";
  const cost = costs[isVideo ? "video_effect" : "photo_effect"];

  const run = (p, label) => {
    setError("");
    if (isVideo && file.duration > 30.05) { setError(te("Vidéo trop longue (30 s max pour les effets IA)")); return; }
    if (isVideo && file.duration < 3) { setError(te("Vidéo trop courte (3 s min)")); return; }
    onLaunch({ type: isVideo ? "video_effect" : "photo_effect", prompt: p, label });
  };

  return (
    <div className="frz-tabpane" data-testid="tabpane-fx">
      <h4 className="frz-label">{t("fx_presets")} <CostTag n={cost} testId="fx-preset-cost" /></h4>
      <div className="frz-fx-grid">
        {EFFECT_PRESETS.map(({ id, icon: Icon, color, prompt: p }) => (
          <button key={id} type="button" className="frz-fx" style={{ "--fx": color }} disabled={disabled}
            onClick={() => run(p, t(`fx_${id}`))} data-testid={`preset-${id}`}>
            <Icon size={18} />
            <span>{t(`fx_${id}`)}</span>
          </button>
        ))}
      </div>
      <h4 className="frz-label">{t("fx_free")}</h4>
      <textarea className="frz-textarea" rows={3} value={prompt} placeholder={t("fx_free_ph")} onChange={(e) => setPrompt(e.target.value)} data-testid="fx-prompt-input" />
      {isVideo && <p className="frz-hint" data-testid="fx-video-note">{t("fx_video_note", { n: Math.max(1, Math.ceil(file.duration / 10 - 1e-6)) })}</p>}
      {error && <p className="frz-error" data-testid="fx-error">{error}</p>}
      <button type="button" className="frz-btn frz-btn-primary frz-btn-block" disabled={disabled || prompt.trim().length < 3}
        onClick={() => run(prompt.trim(), prompt.trim().slice(0, 60))} data-testid="apply-fx-button">
        <Sparkles size={16} /> {t("apply_fx")} <CostTag n={cost} testId="fx-cost" />
      </button>
    </div>
  );
};
